<template>
    <el-select class="td_select"
               v-model="values"
               default-first-option
               filterable
               remote
               reserve-keyword
               placeholder="请输入子项目名称"
               :clearable="clearable"
               :disabled="disabled"
               :remote-method="remoteMethod"
               @clear="clearAction"
               :loading="loading">
        <el-option
                class="td_option"
                v-for="item in options"
                :key="item.id"
                :label="item.subproject"
                :value="item.subproject"
                @click.native="handleSelect(item)">
        </el-option>
    </el-select>
</template>
<script>
import { validatenull } from '@/tdcommon/validate'
// import { getChildProject } from '@/api/basic/subproject'
import { getSubprojectQuotation } from '@/api/basic/subprojectQuotation'
// 获取子项目报价单的子项目（搜索下拉）
export default {
  name: 'd2-child-subprojectQuotation-select',
  data () {
    return {
      values: this.value,
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    url: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    remoteMethod (query) {
      this.loading = true
      var searchStr = validatenull(query) ? '' : query
      getSubprojectQuotation(searchStr).then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.$emit('change', val)
    },
    clearAction () {
      this.$emit('change', '')
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val.toString())
    },
    value: function (val, oldVal) {
      this.remoteMethod(val)
      this.values = val
      // this.$emit('change', '')
    }
  },
  mounted () {
    this.remoteMethod(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-child-subprojectQuotation-select/index.vue"
}
</vue-filename-injector>
